import * as React from "react";
import FormSelect from './FormSelect';

interface Props {
    format?: ("dd" | "mm" | "yyyy")[],
    name?: string,
    placeholder?: string,
    label?: string,
    required?: boolean,
    className?: string,
    value?: any,
    onChange?: any
}

interface State {
    dd?: number;
    mm?: number;
    yyyy?: number;
}

export default class FormDate extends React.Component<Props, State> {
    state = {} as State;
    name: string;

    constructor(props) {
        super(props);

        this.name = this.getName();
        if (this.props.value) {
            const [date, time] = this.props.value.split(' ');
            const [yyyy,mm,dd] = date.split('-');
            this.state = {
                yyyy,
                mm,
                dd
            }
        } else {
            if (!props.format.includes('dd')) {
                this.state = {
                    dd: 1
                }
            }
        }
    }

    getName() {
        if(this.props.name)
            return this.props.name;

        if(this.props.label)
            return this.props.label.toLowerCase();

        let rnd = Math.floor(Math.random() * 999999) + 1;

        return "form-input-text-" + rnd;
    }

    getLabel() {
        return this.props.label ?
            <label className={"label_input"} htmlFor={this.name}>{this.props.label}
                { this.props.required && <span className="required">*</span> }
            </label> : "";
    }

    onChange(sub, val) {
        const newState = {
            ...this.state,
            [sub]: val
            //value: e.target.value
        }
        if (this.props.onChange && newState.yyyy && newState.mm && newState.dd) {
            this.props.onChange(this.name, `${newState.yyyy}-${newState.mm}-${newState.dd}`);
        }

        this.setState(newState);
    }

    render() {
        const { format = ["dd", "mm", "yyyy"] } = this.props;
        const { dd, mm, yyyy } = this.state;

        const curr = (new Date()).getFullYear();
        const years = 60;
        const endYear = curr;

        let cells = 0;
        if (format.includes('dd')) cells++;
        if (format.includes('mm')) cells++;
        if (format.includes('yyyy')) cells++;
        
        return (
            <div className="form-group date-input">
                { this.getLabel() }
                <div className="row">
                    {format.includes('dd') && 
                    <div className={`col-xs-12 col-sm-${12/cells}`}>
                        <FormSelect placeholder={"Giorno"} name={"dd"} value={ dd }
                            values={Array.from(new Array(31),(val,index)=>({key: index+1, value: index+1}))} required onChange={(_, v) => this.onChange('dd', v)} />
                    </div>
                    }
                    {format.includes('mm') && 
                    <div className={`col-xs-12 col-sm-${12/cells}`}>
                        <FormSelect placeholder={"Mese"} name={"mm"} value={ mm }
                            values={Array.from(new Array(12),(val,index)=>({key: (index < 9) ? ('0' + parseInt(index +1)) : index+1 , value:(index < 9) ? ('0' + parseInt(index +1)) : index+1}))} required onChange={(_, v) => this.onChange('mm', v)} />
                    </div>
                    }
                    {format.includes('yyyy') && 
                    <div className={`col-xs-12 col-sm-${12/cells}`}>
                        <FormSelect placeholder={"Anno"} name={"yyyy"} value={ yyyy }
                            values={Array.from(new Array(years+1),(val,index)=>({key: endYear-index, value: endYear-index}))} required onChange={(_, v) => this.onChange('yyyy', v)} />
                    </div>
                    }
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/FormDate.tsx